import PropTypes from 'prop-types';
import StatCard from './StatCard';

export default function StatsGrid({ stats = [] }) {
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <StatCard
          key={index}
          icon={stat.icon}
          label={stat.label}
          value={stat.value}
          change={stat.change}
          changeType={stat.changeType}
          variant={stat.variant}
          details={stat.details}
        />
      ))}
    </div>
  );
}

StatsGrid.propTypes = {
  stats: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.elementType,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    change: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    changeType: PropTypes.oneOf(['positive', 'negative', 'neutral']),
    variant: PropTypes.oneOf(['primary', 'accent', 'destructive', 'success']),
    details: PropTypes.string,
  })),
};

StatsGrid.defaultProps = {
  stats: [],
};
